import { axiosFinancial, createAuthHeaders } from "./financialApi";

export const downloadConciliationExcel = async (
  startDate: Date | null,
  endDate: Date | null,
  corbanIds: number[]
): Promise<Blob> => {
  try {
    if (!startDate || !endDate) {
      throw new Error("Missing required parameters");
    }

    const response = await axiosFinancial.get("/api/conciliation-excel", {
      params: {
        startDate: startDate.toISOString().split("T")[0],
        endDate: endDate.toISOString().split("T")[0],
        corbanIds,
      },
      responseType: "blob",
      headers: createAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
